import './message.scss';

import { kebabCase } from 'lodash';

export enum MessageType {
  DEFAULT = 'DEFAULT',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  INFO = 'INFO',
}

type MessageProps = {
  type?: MessageType;
  message: JSX.Element | string | null | undefined;
};

export function Message({ type = MessageType.DEFAULT, message }: MessageProps) {
  if (!message) return null;

  return (
    <div className={`message message--${kebabCase(type)}`}>
      <p>{message}</p>
    </div>
  );
}
